export default {
  state: {
    page: 1,
    filterParams: {
      progress_status: '',
      origin_type: '',
      start: '',
      end: '',
      staff_id: '',
      period: '',
      keyword: '',
      province: '',
      city: '',
      order_num: '',
      customer_level_id: '',
      repurchase: '',
      has_order: false
    }
  },
  actions: {
    storeParams ({ commit, state, dispatch }, data) {
      commit('setFilterParams', data)
    },
    resetParams (commit, state, dispatch) {
      commit('setFilterParams', {})
    }
  },
  mutations: {
    setFilterParams (state, params) {
      state.filterParams = params
    },
    setPage (state, page) {
      state.page = page
    }
  },
  getters: {
    getFilterParams (state) {
      return state.filterParams
    }
  }
}
